import React from 'react';
import { useLocale } from '../../hooks/useLocale';
import { useStoreActions, useStoreState } from '../../store';
import { LanguageMenuScreen } from '../../store/languageMenu';
import { MenuHeader } from './MenuHeader';
import { OptionRow, SubmenuScreenContent } from './styles';

export const SubtitlesScreen = () => {
  const locale = useLocale();
  const actions = useStoreActions((actions) => actions);
  const webVttSubtitles = useStoreState((state) => state.subtitles.webVttSubtitles);
  const activeSubtitle = useStoreState((state) => state.subtitles.activeSubtitle);

  function handleSubtitleChange(subtitle: TextTrack | null) {
    actions.subtitles.setActiveSubtitle(subtitle);
    actions.settings.setSubtitleTrack(subtitle);
  }

  const rightAction =
    webVttSubtitles.length > 0
      ? {
          label: locale.translations.LanguageOptions.SubtitleOptions,
          onPress: () => actions.languageMenu.navigateTo(LanguageMenuScreen.Options),
        }
      : undefined;

  return (
    <SubmenuScreenContent>
      <MenuHeader
        title={locale.translations.LanguageOptions.Subtitles}
        onBack={() => actions.languageMenu.navigateBack()}
        rightAction={rightAction}
      />
      <OptionRow active={activeSubtitle === null} onClick={() => handleSubtitleChange(null)}>
        {locale.translations.General.Off}
      </OptionRow>
      {webVttSubtitles.map((webVttSubtitle: TextTrack) => (
        <OptionRow
          key={`webvtt-${webVttSubtitle.id}`}
          active={webVttSubtitle.label === activeSubtitle?.label}
          onClick={() => handleSubtitleChange(webVttSubtitle)}
        >
          {webVttSubtitle.label}
        </OptionRow>
      ))}
    </SubmenuScreenContent>
  );
};
